import { render, staticRenderFns } from "./SettingsGeneralQuote.vue?vue&type=template&id=ab7b5ba6&"
import script from "./SettingsGeneralQuote.vue?vue&type=script&lang=js&"
export * from "./SettingsGeneralQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports